import React, { useState } from 'react';
import { BookOpen, Pen, Target, Smile, Paintbrush, Sparkles, Layout } from 'lucide-react';
import { DoodleStrip } from './Doodles';
import DailyLog from './DailyLog';
import HabitTracker from './HabitTracker';
import MoodTracker from './MoodTracker';
import DoodlePad from './DoodlePad';
import JournalStudio from './JournalStudio';
import CustomOverviews from './CustomOverviews';

const BUJO_TABS = [
  { key: 'daily', label: 'Daily Log', icon: Pen, bg: '#FDF0D5' },
  { key: 'habits', label: 'Habits', icon: Target, bg: '#A2D2FF' },
  { key: 'mood', label: 'Mood', icon: Smile, bg: '#FFC8DD' },
  { key: 'doodle', label: 'Doodle', icon: Paintbrush, bg: '#B9FBC0' },
  { key: 'studio', label: 'Studio', icon: Sparkles, bg: '#CDB4DB' },
  { key: 'overviews', label: 'Overviews', icon: Layout, bg: '#FDF0D5' },
];

export default function BujoPage() {
  const [activeTab, setActiveTab] = useState('daily');

  return (
    <div className="space-y-6 relative" data-testid="bujo-page">
      {/* Header */}
      <div className="text-center">
        <div className="flex items-center justify-center gap-3 mb-2">
          <BookOpen className="w-7 h-7" />
          <h2 className="text-3xl font-bold font-['Fredoka']">My Bullet Journal</h2>
        </div>
        <DoodleStrip />
      </div>

      {/* Sub-tabs */}
      <div className="flex gap-2 justify-center flex-wrap">
        {BUJO_TABS.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`neo-btn px-4 py-2 flex items-center gap-2 ${
                activeTab === tab.key ? '' : 'bg-white'
              }`}
              style={activeTab === tab.key ? { backgroundColor: tab.bg } : {}}
              data-testid={`bujo-tab-${tab.key}`}
            >
              <Icon className="w-5 h-5" />
              <span className="hidden sm:inline">{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Content */}
      {activeTab === 'daily' && <DailyLog />}
      {activeTab === 'habits' && <HabitTracker />}
      {activeTab === 'mood' && <MoodTracker />}
      {activeTab === 'doodle' && <DoodlePad />}
      {activeTab === 'studio' && <JournalStudio />}
      {activeTab === 'overviews' && <CustomOverviews />}
    </div>
  );
}
